module.exports = __webpack_public_path__ + "images/emoji/satellite.1ebb7744c154ba2e5b61.png";